function Avaliacaoes() {
  return (
    <section id="reviews" className="reviews">
        <div className="container">
            <h2>Avaliações</h2>
            <div className="rating-summary">
                <div className="stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                </div>
                <p>EXCELENTE • Baseado em 67 avaliações</p>
            </div>
            <div className="review-grid">
                <div className="review-item">
                <h4>Antonio Carlos Novaes <span>02/04/2025</span></h4>
                <p>Equipamentos muito conservados e grande agilidade na entrega.</p>
                </div>
                <div className="review-item">
                <h4>Marcelo Antero <span>27/03/2025</span></h4>
                <p>Excelente profissional indico a todos!</p>
                </div>
                <div className="review-item">
                <h4>Pedrina Souza Amaral <span>27/03/2025</span></h4>
                <p>Super recomendo. Prestativos e atenciosos!</p>
                </div>
            </div>
        </div>
    </section>
  );
}

export default Avaliacaoes;
